<template>
  <div class="eventBaseForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :rules="rules"
      :disabled="$route.query.type == 'query'"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  import COMMON_API from '@/api/financeCenter/commonVoucherTemplate';

  export default {
    name: 'eventBaseForm',
    components: {
      baseForm,
    },
    props: ['type'],
    data() {
      return {
        baseData: {
          id: null,
          applicationCode: null,
          entityCode: null,
          eventCode: null,
          eventName: null,
          eventDesc: null,
          accountCondition: null,
          enableFlag: 'Y',
        },
        applicationList: [],
        entityList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            type: 'select',
            label: '业务模块代码',
            prop: 'applicationCode',
            options: this.applicationList,
            valueKey: 'applicationCode',
            labelKey: 'applicationName',
            required: true,
          },
          {
            type: 'select',
            label: '业务实体代码',
            prop: 'entityCode',
            options: this.entityList,
            valueKey: 'entityCode',
            labelKey: 'entityName',
            required: true,
          },
          {
            type: 'input',
            label: '事件分类代码',
            prop: 'eventCode',
            required: true,
          },
          {
            type: 'input',
            label: '事件分类名称',
            prop: 'eventName',
            clearable: true,
          },
          {
            type: 'select',
            label: '是否启用',
            prop: 'enableFlag',
            clearable: true,
            options: [
              { value: 'Y', label: '启用' },
              { value: 'N', label: '停用' },
            ],
          },
          {
            type: 'input',
            label: '事件分类描述',
            prop: 'eventDesc',
            clearable: true,
          },
          {
            type: 'textarea',
            label: '取值逻辑',
            prop: 'accountCondition',
            clearable: true,
            span: 12,
          },
        ];
      },
      rules() {
        return {};
      },
    },
    mounted() {
      this.getApplicationList();
      this.getEntityList();
    },
    methods: {
      getApplicationList() {
        this.$axios.post(COMMON_API.QUERY_AE_APPLICATION, {}).then((res) => {
          if (res.data.code == 0) {
            this.applicationList = res.data.data;
          }
        });
      },
      getEntityList() {
        this.$axios.post(COMMON_API.QUERY_AE_ENTITY, {}).then((res) => {
          if (res.data.code == 0) {
            this.entityList = res.data.data;
          }
        });
      },
      // 返回数据
      exportChildData() {
        // 点击提交，走校验
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
<style lang="scss" scoped></style>
